"use strict";function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=e(require("styled-components")).default.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-row-gap: 11px;
`;module.exports=t;
//# sourceMappingURL=styles.js.map
